import {
  generateCanonicalUrlForStaticPageFactory,
  generatePaginatedCanonicalUrl,
  checkIfNonCanonicalPathFactory
} from '@fmpedia/helpers'
import { generateIlUrl } from './url-generators'

export { generatePaginatedCanonicalUrl }

let generateCanonicalUrlForStaticPageFn

export const generateCanonicalUrlForStaticPage = (ctx, options) => {
  if (!generateCanonicalUrlForStaticPageFn) {
    generateCanonicalUrlForStaticPageFn = generateCanonicalUrlForStaticPageFactory(
      {
        pathToUrlGenerator: path => {
          return generateIlUrl(path, ctx)
        },
        defaultEndingSlash: true
      }
    )
  }

  return generateCanonicalUrlForStaticPageFn(options)
}

let checkIfNonCanonicalPathFn

export const checkIfNonCanonicalPath = (ctx, options) => {
  function pathToUrlGenerator(path) {
    return generateIlUrl(path, ctx)
  }

  if (!checkIfNonCanonicalPathFn) {
    checkIfNonCanonicalPathFn = checkIfNonCanonicalPathFactory({
      pathToUrlGenerator
    })
  }

  return checkIfNonCanonicalPathFn(options)
}
